import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-private-conditions',
  templateUrl: './private-conditions.component.html'
})
export class PrivateConditionsComponent implements OnInit {
  @ViewChild('acceptConditions') conditionsModal: ModalDirective;
  @Output() acceptTerms = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onAcceptTerms() {
    this.acceptTerms.emit(true);
  }

  openModal() {
    this.conditionsModal.show();
  }

  closeModal() {
    this.conditionsModal.hide();
  }
}
